import useFormInputUploadDocumentsFileTakePhoto, {
  FILE_ACCEPT,
} from 'features/profileKYC/hooks/useFormInputUploadDocumentsFileTakePhoto';
import CheckCameraToTakePhotoEnableAlertModal from 'features/uploadDocuments/modals/CheckCameraToTakePhotoEnableAlertModal';
import { useCameraCheck } from 'hooks';
import { useDetectDevice } from 'hooks/useDetectDevice';
import useLang from 'hooks/useLang';
import React, { useState } from 'react';
import { Form } from 'react-bootstrap';
import styled from 'styled-components';
import FormInputUploadDocumentsFileTakePhotoMask from './FormInputUploadDocumentsFileTakePhotoMask';

const FormInputUploadDocumentsFileSelectTakePhotoMask = ({
  field,
  information,
  setInformation,
  validation,
  setValidation,
}) => {
  const { t } = useLang();

  const { isDesktop } = useDetectDevice();
  const { checkAllowTakePhoto } = useCameraCheck();
  const { getUploadDocumentsFileTakePhoto } =
    useFormInputUploadDocumentsFileTakePhoto();

  const [
    isShowCheckCameraToTakePhotoEnableAlertModal,
    setShowCheckCameraToTakePhotoEnableAlertModal,
  ] = useState(false);

  const handleOnChange = async (e) => {
    console.log(
      `⭐ FormInputUploadDocumentsFileSelectTakePhotoMask 👉 handleOnChange ➡️ CLICKED ↩`
    );
    await getUploadDocumentsFileTakePhoto({
      e,
      field,
      information,
      setInformation,
      validation,
      setValidation,
    });

    if (e.target.value) {
      e.target.value = null;
    }
  };

  const handleOnClick = async (e) => {
    if (isDesktop) return;
    if (!checkAllowTakePhoto) {
      setShowCheckCameraToTakePhotoEnableAlertModal(true);
      e.preventDefault();
      e.stopPropagation();
      return;
    }
  };

  const renderCheckCameraToTakePhotoEnableAlertModal = () => {
    if (!isShowCheckCameraToTakePhotoEnableAlertModal) return null;
    return (
      <CheckCameraToTakePhotoEnableAlertModal
        isShow={isShowCheckCameraToTakePhotoEnableAlertModal}
        modalOptions={{
          zIndexBackdropOverlap: 1070,
          zIndexModal: 1071,
        }}
        actionClose={() => setShowCheckCameraToTakePhotoEnableAlertModal(false)}
      />
    );
  };

  return (
    <>
      {renderCheckCameraToTakePhotoEnableAlertModal()}

      <FormInputUploadDocumentsFileSelectTakePhotoMaskStyled>
        <canvas id={`pdf-canvas-${field.name}`} style={{ display: 'none' }} />
        <FormControl
          id={field.name}
          type={field.type}
          name={field.name}
          isInvalid={validation[field.name]}
          onChange={handleOnChange}
          onClick={handleOnClick}
          accept={FILE_ACCEPT.join(', ')}
        />
      </FormInputUploadDocumentsFileSelectTakePhotoMaskStyled>
      <FormInputUploadDocumentsFileTakePhotoMask
        name={field.name}
        label={t(field.label)}
      />
    </>
  );
};

const FormInputUploadDocumentsFileSelectTakePhotoMaskStyled = styled.div`
  position: relative;
  z-index: 1;
`;

const FormControl = styled(Form.Control)`
  width: 100%;
  height: 100%;
  border-radius: 12px;
  padding: 0px;
  margin: 0px;

  &:invalid,
  &:invalid:focus,
  &.is-invalid {
    border-radius: 12px;
    outline: none !important;
    box-shadow: none !important;
    padding: 0px;
  }

  &[type='file'] {
    opacity: 0;
  }
`;

export default FormInputUploadDocumentsFileSelectTakePhotoMask;
